import * as THREE from 'three';
import ObjectArrayView from '../../generic/container/ObjectArrayView';
import ObjectsByName from '../../generic/container/ObjectsByName';
import ObjectBuffer from '../../generic/container/ObjectBuffer';
import PolyMesh from '../model/PolyMesh';
import PolyMap from '../model/PolyMap';

export default function removeDuplicateIndices(polyMesh, withLogging) {

  const l = withLogging || false;

  const faceRangeOffsets = new Uint32Array(polyMesh.positions.faceRangeOffsets);
  const faceValueIndices = new Uint32Array(polyMesh.positions.faceValueIndices);
  const normalFaceValueIndices = new Uint32Array(polyMesh.normalMap.faceValueIndices);

  const uvMapNames = [];
  const uvMapsNewIndices = [];
  if (polyMesh.uvMaps) {
    for (let i = 0; i < polyMesh.uvMaps.length; i++) {
      uvMapNames.push(polyMesh.uvMaps.namesByIndex[i]);
      uvMapsNewIndices.push(new Uint32Array(polyMesh.uvMaps.byName[uvMapNames[i]].faceValueIndices));
    }
  }

  let newIndicesMarker = 0;

  let previousFaceIndex = 0;
  let currentFaceIndex = 0;
  let currentFaceSize = 0;
  let newFaceSize = 0;

  //stores [index value, index];
  const uniqueIndicesMap = new Map();

  //Check every face
  for (let i = 1; i < faceRangeOffsets.length; i++) {

    currentFaceIndex = faceRangeOffsets[i];
    currentFaceSize = currentFaceIndex - previousFaceIndex;
    newFaceSize = currentFaceSize;

    //check unique
    uniqueIndicesMap.clear();
    for (let j = 0; j < currentFaceSize; j++) {
      uniqueIndicesMap.set(faceValueIndices[previousFaceIndex + j], previousFaceIndex + j);
    }

    newFaceSize = uniqueIndicesMap.size;
    //special case face of size 1
    if (newFaceSize === 1) {
      if (l && currentFaceSize > 1) console.log('Face ' + i + ' has only 1 unique value. Reducing to a point...');
      faceRangeOffsets[i] = faceRangeOffsets[i - 1] + 1;
      faceValueIndices[newIndicesMarker++] = faceValueIndices[previousFaceIndex];

    } else {
      if (l && currentFaceSize === 2) console.log('Face ' + i + ' has only 2 unique values. Reducing to a line...');

      faceRangeOffsets[i] = faceRangeOffsets[i - 1] + newFaceSize;
      let entries = uniqueIndicesMap.entries();

      let element;
      for (element of entries) {
        normalFaceValueIndices[newIndicesMarker] = normalFaceValueIndices[element[1]];
        for (let k = 0; k < uvMapsNewIndices.length; k++) {
          uvMapsNewIndices[k][newIndicesMarker] = uvMapsNewIndices[k][element[1]];
        }

        faceValueIndices[newIndicesMarker++] = element[0];
      }
    }

    previousFaceIndex = currentFaceIndex;
  }

  if (l) console.log('' + faceValueIndices.length + ' index values reduced to ' + newIndicesMarker + ', duplicates removed: ' + (faceValueIndices.length - newIndicesMarker));

  const newIndices = new Uint32Array(faceValueIndices.subarray(0, newIndicesMarker));
  const newNormalIndices = new Uint32Array(normalFaceValueIndices.subarray(0, newIndicesMarker));

  const positions = new PolyMap({
    faceRangeOffsets: faceRangeOffsets,
    faceValueIndices: newIndices,
    values: polyMesh.positions.values,
  });

  const results = new PolyMesh();
  results.positions = positions;
  results.faceRangeOffsets = results.positions.faceRangeOffsets;

  const normalMap = new PolyMap({
    faceRangeOffsets: results.faceRangeOffsets,
    faceValueIndices: newNormalIndices,
    values: polyMesh.normalMap.values,
  });
  results.normalMap = normalMap;

  if (polyMesh.uvMaps) {
    let uvMaps = new ObjectsByName();
    for (let i = 0; i < polyMesh.uvMaps.length; i++) {
      let name = polyMesh.uvMaps.namesByIndex[i];
      const uvMap = new PolyMap({
        faceRangeOffsets: results.faceRangeOffsets,
        faceValueIndices: uvMapsNewIndices[i],
        values: polyMesh.uvMaps.byName[name].values,
      });
      uvMaps.set(name, uvMap);
    }

    results.uvMaps = uvMaps;
  }

  return results;
};



// WEBPACK FOOTER //
// ./src/polyMesh/geometric/operator/removeDuplicateIndices.js